import React from "react";
//#region types
import { WintSuperkollAPIModel as ApiModels } from "wint-api-client/dist/types";
import { SalaryDraftStatusTagsProps } from "models/propTypes/salaryPropTypes";
//#endregion
//#region components
import { useSalaryService } from "serviceHooks";
import { Tags } from "components/common";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const SalaryDraftStatusTags: React.FC<SalaryDraftStatusTagsProps> = (props) => {
  const salaryService = useSalaryService();
  const { state } = props;

  const getLabelClass = (status: ApiModels.SalaryDraftState) => {
    switch (status) {
      case ApiModels.SalaryDraftState.NotSent:
      case ApiModels.SalaryDraftState.AtCustomer:
        return cssExports.yellowTag;
      case ApiModels.SalaryDraftState.Approved:
        return cssExports.blueTag;
      case ApiModels.SalaryDraftState.Handled:
        return cssExports.greenTag;
      case ApiModels.SalaryDraftState.Rejected:
      case ApiModels.SalaryDraftState.Removed:
        return cssExports.redTag;
      default:
        return cssExports.grayTag;
    }
  };

  return <Tags tags={[salaryService.getSalaryDraftStateText(state)]} className={getLabelClass(state)} />;
};

export default SalaryDraftStatusTags;
